// import React from "react";
// import { Link } from "react-router-dom";
// import Usernav from "../usernav/usernav";
// import { MdShoppingBag } from "react-icons/md";
// import "./userorder.css"
// const UserOrder = () => {
//     return (
//         <>
//             <div className="breadcrumb-wrap bg-f br-2 mt-5">
//                 <div className="container">
//                     <div className="breadcrumb-title">
//                         <h2>My Orders</h2>
//                         <ul className="breadcrumb-menu list-style">
//                             <li><Link to="#">Home </Link></li>
//                             <li>My Orders</li>
//                         </ul>
//                     </div>
//                 </div>
//             </div>


//             <div>
//                 <div className="ordercon gap-2">
//                     <Usernav />
//                     <div class="col-xl-8 col-lg-12 orders">

//                         <div className="d-flex"><div className="person"><MdShoppingBag /></div> <span style={{ fontSize: "20px" }}>My Orders</span></div>
//                         <div className="ordercontiner">
//                             <ul className="orderdata">
//                                 <li>order#172637157218274</li>
//                                 <li>Pending</li>
//                                 <li>10-Nov-2024</li>
//                                 <li>Rs.1000</li>
//                                 <li>{"->"}</li>
//                             </ul>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };
// export default UserOrder;


// import React, { useState, useEffect } from 'react';
// import { Link } from "react-router-dom";
// import Usernav from "../usernav/usernav";
// import { MdShoppingBag } from "react-icons/md";

// const UserOrder = () => {
//     const [orders, setOrders] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const phoneNumber = localStorage.getItem("phoneNumber");

//     useEffect(() => {
//         const fetchOrders = async () => {
//             try {
//                 const response = await fetch('/api/orders'); // Replace with your API endpoint
//                 const data = await response.json();
//                 // Filter orders based on phone number
//                 const userOrders = data.filter(order => 
//                     order.customerId === phoneNumber
//                 );
//                 setOrders(userOrders);
//             } catch (error) {
//                 console.error('Error fetching orders:', error);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchOrders();
//     }, [phoneNumber]);

//     // Helper function to format date
//     const formatDate = (dateString) => {
//         const date = new Date(dateString);
//         return date.toLocaleDateString('en-IN', {
//             day: '2-digit',
//             month: 'short',
//             year: 'numeric'
//         });
//     };

//     return (
//         <>
//             <div className="breadcrumb-wrap bg-f br-2 mt-5">
//                 <div className="container">
//                     <div className="breadcrumb-title">
//                         <h2>My Orders</h2>
//                         <ul className="breadcrumb-menu list-style">
//                             <li><Link to="/">Home </Link></li>
//                             <li>My Orders</li>
//                         </ul>
//                     </div>
//                 </div>
//             </div>

//             <div>
//                 <div className="ordercon gap-2">
//                     <Usernav />
//                     <div className="col-xl-8 col-lg-12 orders">
//                         <div className="d-flex">
//                             <div className="person"><MdShoppingBag /></div>
//                             <span style={{ fontSize: "20px" }}>My Orders</span>
//                         </div>

//                         {loading ? (
//                             <div className="text-center p-4">Loading orders...</div>
//                         ) : orders.length === 0 ? (
//                             <div className="text-center p-4">No orders found</div>
//                         ) : (
//                             <div className="ordercontiner">
//                                 {orders.map((order) => (
//                                     <div key={order._id.$oid} className="order-item mb-3">
//                                         <ul className="orderdata">
//                                             <li>Order #{order.orderId}</li>
//                                             <li className={`status-${order.deliveryStatus.toLowerCase()}`}>
//                                                 {order.deliveryStatus.charAt(0).toUpperCase() + 
//                                                  order.deliveryStatus.slice(1)}
//                                             </li>
//                                             <li>{formatDate(order.orderDate.$date)}</li>
//                                             <li>Rs.{order.paymentDetails.totalAmount}</li>
//                                             <li>
//                                                 <Link to={`/order-details/${order._id.$oid}`}>
//                                                     {">"}
//                                                 </Link>
//                                             </li>
//                                         </ul>
//                                         <div className="order-products">
//                                             {order.products.map((product) => (
//                                                 <div key={product._id.$oid} className="product-summary">
//                                                     <img 
//                                                         src={product.image} 
//                                                         alt={product.productName}
//                                                         className="product-thumbnail"
//                                                     />
//                                                     <div className="product-info">
//                                                         <p>{product.productName}</p>
//                                                         <p>Size: {product.size}</p>
//                                                         <p>Quantity: {product.quantity}</p>
//                                                     </div>
//                                                 </div>
//                                             ))}
//                                         </div>
//                                     </div>
//                                 ))}
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default UserOrder;

import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import Usernav from "../usernav/usernav";
import { MdShoppingBag } from "react-icons/md";
import { VscArrowRight } from "react-icons/vsc";
import './userorder.css';

const UserOrder = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const phoneNumber = localStorage.getItem("phoneNumber");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await fetch('/api/orders');
        const data = await response.json();
        const userOrders = data.filter(order => order.customerId === phoneNumber);
        setOrders(userOrders);
      } catch (error) {
        console.error('Error fetching orders:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchOrders();
  }, [phoneNumber]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  const handleViewOrderClick = (orderId) => {
    navigate('/Userorderdetails', { state: { orderId } });
  };

  const isWithinCancelWindow = (orderDate) => {
    const orderTime = new Date(orderDate).getTime();
    const currentTime = new Date().getTime();
    return currentTime - orderTime <= 3 * 60 * 60 * 1000;
  };

  const getTimeRemaining = (orderDate) => {
    const orderTime = new Date(orderDate).getTime();
    const currentTime = new Date().getTime();
    const timeRemaining = (orderTime + 3 * 60 * 60 * 1000) - currentTime;
    if (timeRemaining <= 0) return "";
    const hoursLeft = Math.floor(timeRemaining / (1000 * 60 * 60));
    const minutesLeft = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    return `${hoursLeft}h ${minutesLeft}m left to cancel`;
  };

  const handleCancelOrder = async (orderId) => {
    try {
      const response = await fetch('/api/cancel-order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ orderId })
      });
      const data = await response.json();
      if (response.ok) {
        alert('Cancellation request has been sent to the admin!');
      } else {
        alert('Error sending cancellation request');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('An error occurred while sending the request');
    }
  };

  return (
    <>
      <div className="breadcrumb-wrap bg-f br-2">
        <div className="container" style={{marginBottom:'-90px'}}>
          <div className="breadcrumb-title">
            <h2>My Orders</h2>
            <ul className="breadcrumb-menu list-style">
              <li><Link to="/">Home</Link></li>
              <li>My Orders</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="containerorder">
        <div className="row">
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
            <div style={{ width: '100%', maxWidth: '320px', padding: '20px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', boxSizing: 'border-box' }}>
              <Usernav />
            </div>

            <div style={{ flex: 1, padding: '24px', background: 'white', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', boxSizing: 'border-box', minWidth: '300px' }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                <div style={{ backgroundColor: '#f0f4f8', padding: '10px', borderRadius: '50%', marginRight: '12px' }}>
                  <MdShoppingBag size={30} color="#4b5563" />
                </div>
                <span style={{ fontSize: "22px", fontWeight: 600, color: '#1f2937' }}>My Orders</span>
              </div>

              {loading ? (
                <div className="loading-state">
                  <p>Loading your orders...</p>
                </div>
              ) : orders.length === 0 ? (
                <div className="empty-state">
                  <MdShoppingBag size={48} />
                  <h4>No orders yet</h4>
                  <p>When you place orders, they will appear here</p>
                  <Link to="/" className="shop-now-btn">Shop Now</Link>
                </div>
              ) : (
                <div className="orders-list">
                  {orders.map(order => (
                    <div key={order._id.$oid || order._id} style={{ border: '1px solid #e5e7eb', borderRadius: '8px', padding: '16px', marginBottom: '16px' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                        <div>
                          <div style={{ fontWeight: 600 }}>Order #{order.orderId}</div>
                          <div style={{ fontSize: '14px', color: '#6b7280' }}>{formatDate(order.orderDate)}</div>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                          <div style={{ fontWeight: 600 }}>₹{order.paymentDetails.totalAmount.toLocaleString()}</div>
                          <span style={{ fontSize: '13px', backgroundColor: '#fef3c7', color: '#92400e', padding: '2px 8px', borderRadius: '4px' }}>{order.deliveryStatus}</span>
                        </div>
                      </div>

                      {order.products.map(product => (
                        <div key={product._id.$oid || product._id} style={{ display: 'flex', gap: '16px', alignItems: 'center', marginBottom: '12px' }}>
                          <img src={product.image} alt={product.productName} style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '6px' }} />
                          <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: 500 }}>{product.productName}</div>
                            <div style={{ fontSize: '13px', color: '#6b7280' }}>Size: {product.size} | Qty: {product.quantity}</div>
                          </div>
                        </div>
                      ))}

                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <a onClick={() => handleViewOrderClick(order._id)} style={{ color: '#2563eb', cursor: 'pointer', fontWeight: 500 }}>View More <VscArrowRight /></a>
                        {order.deliveryStatus === 'pending' && (
                          <div>
                            <button
                              onClick={() => handleCancelOrder(order.orderId)}
                              disabled={!isWithinCancelWindow(order.orderDate)}
                              style={{
                                padding: '6px 12px',
                                borderRadius: '6px',
                                border: 'none',
                                backgroundColor: isWithinCancelWindow(order.orderDate) ? '#ef4444' : '#fca5a5',
                                color: 'white',
                                cursor: isWithinCancelWindow(order.orderDate) ? 'pointer' : 'not-allowed'
                              }}
                            >
                              Cancel
                            </button>
                            <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px' }}>{getTimeRemaining(order.orderDate)}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserOrder;
